export function optionType (value) {

  let key
  switch (value) {
    case 'LOCATION' :
      key = 'booking.options.each_per_rental'
      break
    case 'DAY':
      key = 'booking.options.each_per_day'
      break
  }

  if (key) {
    return i18n.t(key)
  }

}
